<template>
  <ul class="nav nav-tabs nav-tabs-custom nav-success mb-3" role="tablist">
    <li class="nav-item" v-for="(status, index) in skeleton" :key="index">
      <Skeletor width="100px" />
    </li>
  </ul>
</template>

<script>
import { Skeletor } from "vue-skeletor";

export default {
  name: "statuses-tab-skeleton",
  data() {
    return {
      skeleton: 4
    }
  },
  components: {
    Skeletor
  }
}
</script>
